module.exports = __webpack_public_path__ + "img/AAAAAA.2e202513.png";